import { Paper } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  approveClaimMsg,
  noInternetMsg,
  rejectClaimMsg,
  serverMsg,
  statusmsg
} from "../../config/messageconstant";
import { SalesTeamJson } from "../../DynamicFormsJson/MastersJSON/salesTeam";
import { getClaimDetailsForDayEndBeats } from "../../Slice/beat.slice";
import {
  getSalesTeamClaim,
  getSalesTeamClaimForFilterWithAllStatus,
} from "../../Slice/claim.slice";
import {
  SalesTeamColumns
} from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import SalesTeamClaimViewPopUp from "./SalesTeamClaimViewPopUp";

class SalesTeamClaim extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claimDetailsData: {},
      viewPopup: false,
      claimApplyDetails: [],
      DataToSet: [],
      dataList: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const { getSalesTeamClaim, showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      await getSalesTeamClaim({
        monthYear: dayjs().format("MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

  }

  onSearchList = (data) => {
    const { getSalesTeamClaimForFilterWithAllStatus, showLoador, showNotification } = this.props;

    if (navigator.onLine) {

      showLoador({ loador: true });
      getSalesTeamClaimForFilterWithAllStatus({
        monthYear: data.month,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {

        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowViewData = (rowData) => {

    const { getClaimDetailsForDayEndBeats, showLoador, showNotification } =
      this.props;

    const beatAllowanceTypes =
      JSON.parse(localStorage.getItem("isShowBeatAllowanceTypesNames")) || {};

    let beatType1 = beatAllowanceTypes?.beatType1 || "-";
    let beatType2 = beatAllowanceTypes?.beatType2 || "-";

    this.setState({
      fixedCalculation: rowData.fixedCalculation && rowData.fixedCalculation,
    });

    if (rowData.fixedCalculation && rowData.fixedCalculation == 1) {

      showLoador({ loador: true });
      apiGet({
        url: endpoint.beat + "/claim-details-for-day-end-beats-with-edited-data?date="
          + rowData.date + "&salesTeamId=" + rowData.salesTeamId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error", });
        } else {

          let dataList = data.data.beatWorkInfo.map((dataObj, index) => {
            return {
              index: index + 1,
              beatName: dataObj.beatName !== null ? dataObj.beatName : "-",
              beatType: dataObj.beatType !== null ? (dataObj.beatType == 0 ?
                beatType1 : beatType2) : "-",
              travelAllowanceAmt:
                data.data.isEdited == 1 ?
                  dataObj.travelAllowance !== null ? dataObj.travelAllowance.editedClaimAmt.toFixed(2) : "-" :
                  dataObj.travelAllowance !== null ? dataObj.travelAllowance.amt.toFixed(2) : "-",
              dailyAllowanceAmt:
                data.data.isEdited == 1 ?
                  dataObj.dailyAllowance !== null ? dataObj.dailyAllowance.editedClaimAmt.toFixed(2) : "-" :
                  dataObj.dailyAllowance !== null ? dataObj.dailyAllowance.amt.toFixed(2) : "-",
              total:
                data.data.isEdited == 1 ?
                  dataObj.totalEditedClaimAmt !== null ? dataObj.totalEditedClaimAmt.toFixed(2) : "-" :
                  dataObj.total !== null ? dataObj.total.toFixed(2) : "-",
            }
          });
          this.setState({
            DataToSet: [
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Date",
                value: rowData.date !== null ? rowData.date : "",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Sales Team",
                value: rowData.salesTeam !== null ? rowData.salesTeam : "",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Status",
                value:
                  data.data.claimStatus !== null
                    ? data.data.claimStatus == 0
                      ? "Pending for approval"
                      : data.data.claimStatus == 1
                        ? "Cancelled"
                        : data.data.claimStatus == 2
                          ? "Approved"
                          : "Rejected"
                    : "",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Amount",
                value: data.data.finalTotal !== null ? data.data.finalTotal.toFixed(2) : "",
              },
            ],
            viewPopup: true,
            dataList,
          });
        }
      });
    } else {
      let viewDataList = [];
      let claimApplyDetails = [];
      showLoador({ loador: true });
      apiGet({
        url: endpoint.claimApplyHeader + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          claimApplyDetails = data.data.claimApplyDetails.map(
            (dataObj, index) => {
              let dataJson = {
                index: index + 1,
                date: dataObj.date !== null ? dataObj.date : "",
                claimType:
                  dataObj.claimType !== null && dataObj.claimType.name !== null
                    ? dataObj.claimType.name
                    : "",
                claimAmt:
                  dataObj.claimAmt !== null ? dataObj.claimAmt.toFixed(2) : "",
                remark: dataObj.remark !== null ? dataObj.remark : "",
                attachmentStatus: dataObj.attachFile !== null ? "1" : "0",
                attachFile:
                  dataObj.attachFile !== null ? dataObj.attachFile : "",
              };
              return dataJson;
            }
          );
          viewDataList.push(data.data);
          this.setState({
            DataToSet: [
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Date",
                value: data.data.date !== null ? data.data.date : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Sales Team",
                value: data.data.salesTeam !== null && data.data.salesTeam.name !== null &&
                  data.data.salesTeam.stockStakeHolderType !== null &&
                  data.data.salesTeam.stockStakeHolderType.prefix !== null ?
                  data.data.salesTeam.name + " (" + data.data.salesTeam.stockStakeHolderType.prefix + ")" : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Title",
                value: data.data.name !== null ? data.data.name : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Amount",
                value: data.data.claimAmt !== null ? data.data.claimAmt.toFixed(2) : "-",
              },
            ],
            claimApplyDetails: claimApplyDetails,
            viewData: viewDataList,
            viewPopup: true,
          });
        }
      });
    }
  };

  rowCancel = (rowData) => {
    const { showLoador, showNotification } = this.props;
    swal({
      title: "Are you sure?",
      text: rejectClaimMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        const statusCode = 3;
        apiGet({
          url:
            endpoint.claimApplyHeader +
            "/update-status?claimApplyHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            this.getData();
          }
        });
      }
    });
  };

  rowApply = (rowData) => {
    const { showLoador, showNotification } = this.props;
    swal({
      title: "Are you sure?",
      text: approveClaimMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        const statusCode = 2;
        apiGet({
          url:
            endpoint.claimApplyHeader +
            "/update-status?claimApplyHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            this.getData();
          }
        });
      }
    });
  };

  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  render() {
    const {
      SalesClaimList,
      ClaimList,
      beatList,
    } = this.props;
    const {
      viewPopup,
      DataToSet,
      claimApplyDetails,
      fixedCalculation,
      dataList,
    } = this.state;
    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicMainScreen
            formPath={SalesTeamJson.formPath}
            screenTitle={SalesTeamJson.screenTitle}
            fieldMeta={SalesTeamJson.fieldMeta}
            showPdfDownload={SalesTeamJson.showPdfDownload}
            showExcelDownload={false}
            showExtension={false}
            pdfFileName={SalesTeamJson.pdfFileName}
            excelFileName={SalesTeamJson.excelFileName}
            showAddButton={SalesTeamJson.showAddButton}
            tableColumnsToFilter={SalesTeamJson.tableColumnsToFilter}
            tableColumns={SalesTeamColumns}
            tableData={SalesClaimList?.salesTeamClaim}
            getTableData={this.getData}
            apiBaseURL={SalesTeamJson.apiBaseURL}
            baseIdColumn={SalesTeamJson.baseIdColumn}
            showEditIcon={false}
            showDeleteIcon={false}
            showViewButtonInTable={true}
            onSearchData={this.onSearchList}
            searchList={SalesTeamJson.searchList}
            staticView={true}
            rowView={this.rowViewData}
            showCancel={true}
            rowCancel={this.rowCancel}
            showCancelTitle={"Reject Claim"}
            showApply={true}
            showApplyTitle={"Approve Claim"}
            rowApply={this.rowApply}
            cancelBillConditionName="statusForCondition"
            cancelBillConditionValue="0"
            credentialConditionName="statusForCondition"
            credentialConditionValue="0"
            callApi={false}
            getTableDataById={true}
            isNote={true}
            isNoteValue={"To view approved or rejected claims, please use the filter option."}
          />
        </Paper>
        {viewPopup && (
          <SalesTeamClaimViewPopUp
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            columns={
              fixedCalculation == 1
                ? [
                  {
                    title: "Sr. No.",
                    name: "index",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    align: "center",
                  },
                  {
                    title: "Beat Name",
                    name: "beatName",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Beat Type",
                    name: "beatType",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Travel Allowance",
                    name: "travelAllowanceAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                  {
                    title: "Daily Allowance",
                    name: "dailyAllowanceAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                  {
                    title: "Total",
                    name: "total",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                ]
                : [
                  {
                    title: "Sr. No.",
                    name: "index",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    align: "center",
                  },
                  {
                    title: "Claim Type",
                    name: "claimType",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Amount",
                    name: "claimAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },

                  {
                    title: "Remark",
                    name: "remark",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Attachment",
                    name: "action",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    alignCenter: "center",
                    canSearch: true,
                  },
                ]
            }
            rows={
              fixedCalculation == 1
                ? dataList
                : claimApplyDetails
            }
            DataToSet={DataToSet}
            fixedCalculation={fixedCalculation}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  SalesClaimList: state.claim,
  beatList: state.beat,
});
const mapDispatchToProps = {
  getClaimDetailsForDayEndBeats,
  getSalesTeamClaim,
  getSalesTeamClaimForFilterWithAllStatus,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(SalesTeamClaim);
